import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-overlapping-spinner',
    templateUrl: './overlapping-spinner.component.html',
    styleUrls: ['./overlapping-spinner.component.sass'],
    imports: [ProgressSpinnerModule]
})
export class OverlappingSpinnerComponent {

}
